import { useHistory } from 'react-router-dom';
import { Button, Fade, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import HomeLayout from 'layouts/home-layout';

const useStyles = makeStyles(() => ({
  parentContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: '8px',
    color: '#1C2541',
  },
  title: {
    marginTop: '50px',
    fontSize: '32px',
    fontWeight: '700',
  },
  subtitle: {
    marginTop: '40px',
    fontSize: '16px',
  },
  button: {
    marginTop: '24px',
    color: '#31525E',
    fontSize: '14px',
    backgroundColor: '#5ED1F0',
    borderRadius: '100px',
    maxWidth: '600px',
    '&:hover': {
      backgroundColor: '#54bcd8',
    },
  },
}));

const SubscriptionCheckoutSuccessPage = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <HomeLayout>
      <Fade in={true}>
        <div className={classes.parentContainer}>
          <img src="/payment_success.svg" alt="empty documents" />
          <Typography className={classes.title}>Congratulations!</Typography>
          <Typography className={classes.subtitle}>
            You've successfully joined Trustate. Welcome to a new era of seamless estate management.
          </Typography>
          <Button className={classes.button} fullWidth onClick={() => history.replace('/')}>
            Set up your first estate
          </Button>
        </div>
      </Fade>
    </HomeLayout>
  );
};

export default SubscriptionCheckoutSuccessPage;
